<div class="container-head">
    <div>
        <button type="button" class="btn btn-outline-secondary me-2" [disabled]="!!downloadError" (click)="downloadSummary()"><i
                class="bi bi-download"></i>
            {{'COMMON.DOWNLOAD_SUMMARY' | translate }}</button>
        <div *ngIf="downloadError" class="text-danger small mt-1">{{ downloadError | translate }}</div>
    </div>
</div>
<div class="container-filters">
    <hbo-analytics-filters [typeData]="'gazeMapsAnalytics'" (reload)="reload($event)"></hbo-analytics-filters>
</div>
<div class="container-table">
    <hbo-analytics-table *ngIf="packages$ | async as packages" [columns]="columns" [items]="packages" [sortableColumns]="sortableColumns" (reload)="searchPackages($event)" (sortChange)="onSortChange($event)">
        <tbody class="table-group-divider">
            <ng-container *ngFor="let item of data$">
                <tr class="accordion-header">
                    <td>{{ item.id }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.code }}</td>
                    <td>{{ item.team }}</td>
                    <td><strong>{{ item.packageId }}</strong></td>
                    <td>{{ item.packageType }}</td>
                    <td>{{ item.packageCategory }}</td>
                    <td>{{ item.progressive }}</td>
                    <td>{{ item.office }}</td>
                    <td>{{ item.singleVision}}</td>
                    <td>{{ item.total}}</td>
                </tr>
            </ng-container>
            <tr *ngIf="!data$.length">
                <td colspan="9" class="text-center">{{ 'COMMON.NO_RESULTS' | translate }}</td>
            </tr>
        </tbody>
    </hbo-analytics-table>
</div>